@if (!embedded) {
    <app-playground
        [backgrounds]="[
            'https://www.poettinger.at/img/myPoettinger/InfosZurProduktpalette/_MG_8782_2000x1000px.webp',
            'https://www.poettinger.at/img/myPoettinger/InfosZurProduktpalette/_MG_8788_2000x1000px.webp',
            'https://www.poettinger.at/img/myPoettinger/InfosZurProduktpalette/JUMBO_Platzhalter_2000x1000px.webp',
            'https://www.poettinger.at/img/myPoettinger/InfosZurProduktpalette/Maehbalken_Bild_2000x1000px.webp',
            'https://www.poettinger.at/img/myPoettinger/InfosZurProduktpalette/TOP632A_Lindner_17_2000x1000px.webp',
        ]"
        title="{{ 'machinesearch' | translate }}"
    >
        @if (!embedded) {
            <div class="mt-5 mb-5">
                <h3>{{ "machinesearchTitle" | translate }}</h3>
                <p>{{ "machinesearchSub" | translate }}</p>
                <br />
                <p>{{ "machinesearchSub2" | translate }}</p>
            </div>
        }
    </app-playground>
}
<div class="container">
    <router-outlet></router-outlet>
</div>
@if (route.children.length === 0) {
<div class="container machinesearch-actions">
    @if (!machineAdd && !router.url.includes('/myMachines')) {
    <div class="keyword-search">
        <app-product-search></app-product-search>
    </div>
    }

    @if (showChassisInput()) {
    <div class="chassis-search">
        <ion-searchbar
            #chassisSearchbar
            class="searchbar product-searchbar"
            type="search"
            inputmode="search"
            autocomplete="off"
            [autofocus]="true"
            [debounce]="0"
            [(ngModel)]="inpMachinennumber"
            [placeholder]="'Machinenumber' | translate"
            [attr.aria-label]="'Machinenumber' | translate"
            [disabled]="loadsMachineData"
            (keydown.enter)="onClickPfeil()"
        ></ion-searchbar>
        <button
            type="button"
            class="searchbar-submit-button"
            [attr.aria-label]="'productSearch.cards.chassis' | translate"
            [disabled]="loadsMachineData"
            (click)="onClickPfeil()"
        >
            <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
        </button>
        @if (loadsMachineData) {
        <ion-spinner class="chassis-loading" name="crescent"></ion-spinner>
        }
    </div>
    }

    <div class="row pr-2 pl-2">
        @if (!machineAdd && !router.url.includes('/myMachines')) {
        <app-tile
            class="col-sm-6 col-md-4"
            style="padding: 5px"
            imageSrc="/assets/images/Icon_Maschinensuche.svg"
            label="{{ 'productSearch.cards.productRange' | translate }}"
            destination="/machinesearch/productrange"
        ></app-tile>
        }
        <app-tile
            class="col-sm-6"
            [class]="machineAdd || router.url.includes('/myMachines') ? 'col-md-6' : 'col-md-4'"
            style="padding: 5px"
            imageSrc="/assets/images/Icon_SearchChassisNumber.svg"
            label="{{ 'productSearch.cards.chassis' | translate }}"
            (click)="onClickChassisCard()"
            (keydown.enter)="onClickChassisCard()"
        ></app-tile>
        <app-tile
            class="col-sm-6"
            [class]="machineAdd || router.url.includes('/myMachines') ? 'col-md-6' : 'col-md-4'"
            style="padding: 5px"
            imageSrc="/assets/images/Icon_QRCode.svg"
            label="{{ 'productSearch.cards.qr' | translate }}"
            destination="/machinesearch/qrscan"
        ></app-tile>
    </div>
</div>
}
